import { useEffect, useState } from "react";
import { fetchRegions, downloadRegionsExcel } from "../Api/ViewRegion";
import { Container, Table, Button } from "react-bootstrap";

import { toast } from "react-toastify";
import moment from "moment";

const ViewRegion = () => {
  const [regions, setRegions] = useState([]);

  useEffect(() => {
    const loadRegions = async () => {
      try {
        const data = await fetchRegions();
        setRegions(data || []);
      } catch (error) {
        toast.error("🦄 Error Fetching Regions");
      }
    };

    loadRegions();
  }, []);

  const handleDownload = async () => {
    try {
      const response = await downloadRegionsExcel();

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "RegionsData.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      toast.error("🦄 Error downloading Excel file");
    }
  };

  return (
    
      <div>
        <Container className="list-container">
          <div className="header-background">
            <span className="header-list-title">View Regions</span>
            <Button className="gradient-btn" variant="primary" onClick={handleDownload}>
              Download Data
            </Button>
          </div>

          {regions.length > 0 ? (
            <div className="table-wrapper">
              <div className="table-scroll-container">
                <Table bordered hover className="data-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Region</th>
                      <th>Country Code</th>
                      <th>Region Code</th>
                      <th>Region Name</th>
                      <th>Created On</th>
                      <th>Created By</th>
                      <th>Changed On Date</th>
                      <th>Changed Time</th>
                      <th>Changed By</th>
                    </tr>
                  </thead>
                  <tbody>
                    {regions.map((region, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{region.region}</td>
                        <td>{region.countryCode}</td>
                        <td>{region.regionCode}</td>
                        <td>{region.regionName}</td>
                        <td>
                          {region.createdOnDate
                            ? moment(region.createdOnDate).format("L") +
                              " " +
                              region.createdOnTime?.split(".")[0]
                            : "—"}
                        </td>
                        <td>{region.createdBy}</td>
                        <td>
                          {region.changedOnDate
                            ? moment(region.changedOnDate).format("L")
                            : "-"}
                        </td>
                        <td>
                          {region.changedOnTime
                            ? moment(region.changedOnTime, "HH:mm:ss.SSS").format("LTS")
                            : "-"}
                        </td>
                        <td>{region.changedBy}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          ) : (
            <p className="no-data">No regions found.</p>
          )}
        </Container>
      </div>
    
  );
};

export default ViewRegion;
